/* eslint-disable jira/filename-case */
import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('jsm_aiiy_for_nav_item_sidebar');
	},
};
